import React from 'react';

const seedToHue = (seed) => {
  let h = 0;
  for (let i = 0; i < (seed || '').length; i++) h = (h * 31 + seed.charCodeAt(i)) % 360;
  return h;
};

export const CompanionAvatar = ({ name, avatarSeed, size = 48, muted = false }) => {
  const hue = seedToHue(avatarSeed);
  return (
    <div
      className="rounded-full flex items-center justify-center flex-shrink-0"
      style={
        muted
          ? {
              width: size,
              height: size,
              background: `radial-gradient(circle at 35% 30%, hsla(${hue}, 30%, 55%, 0.25), transparent)`,
              border: `1px dashed hsla(${hue}, 40%, 65%, 0.5)`,
            }
          : {
              width: size,
              height: size,
              background: `radial-gradient(circle at 35% 30%, hsla(${hue}, 45%, 65%, 0.85), hsla(${(hue + 40) % 360}, 40%, 40%, 0.6))`,
              boxShadow: `0 0 14px hsla(${hue}, 50%, 60%, 0.35)`,
            }
      }
    >
      <span className="text-sm" style={{ fontFamily: 'Playfair Display, serif', color: muted ? '#4A4A5A' : '#1A1A2E' }}>
        {(name || '?').charAt(0).toUpperCase()}
      </span>
    </div>
  );
};

export const CompanionCard = ({ name, avatarSeed, realmMet, realmName, status, onTap }) => {
  const isConversation = status === 'named_in_conversation';
  return (
    <button
      onClick={onTap}
      className="p-5 rounded-2xl text-left transition-all duration-200 active:scale-[0.97] w-full"
      style={{
        background: '#F7F1EE',
        border: isConversation ? '1px dashed #E5DFD6' : '1px solid transparent',
      }}
      data-testid={`companion-card-${name}`}
    >
      <CompanionAvatar name={name} avatarSeed={avatarSeed} muted={isConversation} />
      <h3 className="text-sm mt-3 mb-0.5" style={{ fontFamily: 'Playfair Display, serif', color: '#1A1A2E' }}>
        {name}
      </h3>
      <p className="text-xs" style={{ fontFamily: 'Jost, sans-serif', color: isConversation ? 'rgba(169,192,174,0.65)' : '#8A6A61' }}>
        {isConversation ? 'Named in conversation' : `Met in ${realmName || `Realm ${realmMet}`}`}
      </p>
    </button>
  );
};
